import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

const BackButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Button variant="outline" onClick={() => navigate(-1)}>
      <ArrowLeft className="mr-1 h-4 w-4" />
      {t('teacher.prev')}
    </Button>
  );
};

export default BackButton;
